import { StyledOtherComponent } from 'create-emotion-styled';
import React from 'react';

import { OmitStrict } from '@tanium/coreui-utils';
import styled from '@tanium/react-emotion-9';
import {
  border,
  borderRadius,
  BorderRadiusStyleProps,
  BorderStyleProps,
  color,
  ColorStyleProps,
  space,
  SpaceStyleProps,
  sxCompose,
} from '@tanium/style-system';

import { Background } from './themeDefinitions';

export interface Props
  extends BorderStyleProps,
    BorderRadiusStyleProps,
    ColorStyleProps,
    SpaceStyleProps {
  /**
   * The well's contents.
   */
  children: React.ReactNode;
  /**
   * A class to apply to the Well. This prop should not generally be used and may have
   * unpredictable results; prefer using other props to customize the appearance of the Well
   * instead.
   */
  className?: string;
}

const StyledWell = styled('div')<Props>(
  sxCompose(space, border, borderRadius, color),
) as StyledOtherComponent<
  Props,
  React.DetailedHTMLProps<
    OmitStrict<React.HTMLAttributes<HTMLDivElement>, 'color'>,
    HTMLDivElement
  >,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any
>;

/**
 * A simple styled container for arbitrary content.
 */
const Well = React.forwardRef<HTMLElement, Props>(({ p = 2, padding = p, ...props }, ref) => (
  <StyledWell innerRef={ref} padding={padding} bg={Background} borderRadius={1} {...props} />
));

export default Well;
